import React, { useState } from "react"
import "./filter.css"
import Dropdown from "react-bootstrap/Dropdown"
import Button from "react-bootstrap/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

function DropFilter({ searchBy, clearFilter, list, filterName }) {
  const [selectedItem, setselectedItem] = useState()

  return (
    <div className='filter-container'>
      <Dropdown>
        <Dropdown.Toggle
          id='dropdown-basic'
          className='myBtn filterBtn'
          variant='success'>
          {selectedItem ? selectedItem : `Search by ${filterName}`}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {list.map((listItem) => {
            return (
              <Dropdown.Item
                key={listItem}
                onClick={() => {
                  searchBy(filterName.toLowerCase(), listItem)
                  setselectedItem(`${listItem} ${filterName}`)
                }}>
                {listItem}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Menu>
      </Dropdown>
      <Button
        className='myBtn clear-btn'
        onClick={() => {
          clearFilter(filterName.toLowerCase())
          setselectedItem()
        }}>
        <FontAwesomeIcon icon={faTimes} />
      </Button>
    </div>
  )
}

export default DropFilter
